var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.331,
    height: 26.331,
    viewBox: "0 0 26.331 26.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5906",
    "data-name": "Group 5906",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M23.943,4.194h-1.1V3.1a1.1,1.1,0,1,0-2.194,0v1.1H16.263V3.1a1.1,1.1,0,1,0-2.194,0v1.1H9.68V3.1a1.1,1.1,0,1,0-2.194,0v1.1h-1.1A4.39,4.39,0,0,0,2,8.583v15.36a4.39,4.39,0,0,0,4.388,4.388H23.943a4.39,4.39,0,0,0,4.388-4.388V8.583a4.39,4.39,0,0,0-4.388-4.388ZM6.389,6.389h1.1v1.1a1.1,1.1,0,1,0,2.194,0v-1.1h4.389v1.1a1.1,1.1,0,0,0,2.194,0v-1.1h4.389v1.1a1.1,1.1,0,1,0,2.194,0v-1.1h1.1a2.195,2.195,0,0,1,2.194,2.194v2.194H4.195V8.583A2.194,2.194,0,0,1,6.389,6.389ZM23.943,26.137H6.389a2.194,2.194,0,0,1-2.194-2.194V12.971H26.138V23.943a2.195,2.195,0,0,1-2.194,2.194Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M24.194,55.1A1.1,1.1,0,0,1,22,55.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-14.514 -37.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M24.194,71.1A1.1,1.1,0,0,1,22,71.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-14.514 -49.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M40.194,55.1A1.1,1.1,0,0,1,38,55.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-26.125 -37.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M40.194,71.1A1.1,1.1,0,0,1,38,71.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-26.125 -49.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M56.194,55.1A1.1,1.1,0,0,1,54,55.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-37.737 -37.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M56.194,71.1A1.1,1.1,0,0,1,54,71.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-37.737 -49.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M72.194,55.1A1.1,1.1,0,0,1,70,55.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-49.348 -37.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M72.194,71.1A1.1,1.1,0,0,1,70,71.1a1.1,1.1,0,0,1,2.194,0",
    transform: "translate(-49.348 -49.349)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.40de757baa30abb0efe7310c2779a8a5.svg";
export { ForwardRef as ReactComponent };